export const CHECKOUT_URL = 'https://matematicaslisto.impultienda.ar/checkout';
